import { useSuspenseQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'
import { ArrowRightIcon } from 'lucide-react'
import { type PropsWithChildren } from 'react'

import { Button } from '@/components/button/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/popover/popover'

import { caseInformationWithHistoryQuery } from '@/lib/queries/business/v2/case/queries'
import { cn } from '@/lib/utils'

import { useFindTargetCase } from '../../hooks/use-find-target-case'

export const CaseInformation = () => {
  const { targetCase } = useFindTargetCase()

  const { data: dataCaseInformation } = useSuspenseQuery(caseInformationWithHistoryQuery(targetCase?.case_id))
  const { dolInformation } = dataCaseInformation ?? {}

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" size="lg" className={cn('w-full', 'h-[56px]', 'p-4')}>
          <p className={cn('mr-auto')}>View more</p>
          <ArrowRightIcon size={24} />
        </Button>
      </PopoverTrigger>
      <PopoverContent side="bottom" align="start">
        <div className={cn('space-y-2')}>
          <div className={cn('flex flex-col', 'space-y-4')}>
            <RowLabel>Employer</RowLabel>
            <RowValue>{dolInformation?.employer_name ?? 'N/A'}</RowValue>
          </div>
          <div className={cn('flex flex-col', 'space-y-4')}>
            <RowLabel>Job Title</RowLabel>
            <RowValue>{dolInformation?.job_title ?? 'N/A'}</RowValue>
          </div>
          <div className={cn('flex flex-col', 'space-y-4')}>
            <RowLabel>Date Filed</RowLabel>
            <RowValue>
              {dolInformation?.submitted_date ? dayjs(dolInformation.submitted_date).format('MMMM DD, YYYY') : 'N/A'}
            </RowValue>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}

const RowLabel = ({ children }: PropsWithChildren) => {
  return (
    <p className={cn('text-sm font-medium leading-5 text-black')} role="term">
      {children}
    </p>
  )
}

const RowValue = ({ children }: PropsWithChildren) => {
  return (
    <p
      className={cn('px-3 py-2', 'text-slate-900', 'bg-elevated', 'rounded-[6px] border border-[#cbd5e1]')}
      role="definition"
    >
      {children}
    </p>
  )
}
